import { array, object, string } from 'yup';

export const fileValidateExtractError = array().of(object().shape({ error: string().length(0) }));
